export class UpdatePurchaseOrderItemMessage {
  canBeUsedToFulfillOrderPart: boolean
  received: boolean

  constructor(canBeUsedToFulfillOrderPart: boolean, received: boolean) {
    this.canBeUsedToFulfillOrderPart = canBeUsedToFulfillOrderPart
    this.received = received
  }
}
  